import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { CompanyState } from '../../types'

export const fetchCompanyDetailsAction = createAsyncAction(
  '@company/FETCH_COMPANY_DETAILS_REQUEST',
  '@company/FETCH_COMPANY_DETAILS_SUCCESS',
  '@company/FETCH_COMPANY_DETAILS_FAILURE'
)<Request, Success, Failure>()

const request = (state: CompanyState): CompanyState => ({
  ...state,
  isLoadingFetchCompanyDetails: true,
  isErrorOnLoadingFetchCompanyDetails: false,
  isSuccessOnLoadingFetchCompanyDetails: false
})

const success = (state: CompanyState, action: ActionType<typeof fetchCompanyDetailsAction.success>): CompanyState => ({
  ...state,
  isLoadingFetchCompanyDetails: false,
  isErrorOnLoadingFetchCompanyDetails: false,
  isSuccessOnLoadingFetchCompanyDetails: true,
  company: action.payload.company
})

const failure = (state: CompanyState): CompanyState => ({
  ...state,
  isLoadingFetchCompanyDetails: false,
  isSuccessOnLoadingFetchCompanyDetails: false,
  isErrorOnLoadingFetchCompanyDetails: true
})

export const fetchCompanyDetailsHandle = { asyncAction: fetchCompanyDetailsAction, request, success, failure }
